

export class TyreBrandOutputWithoutStatus implements ITyreBrandOutputWithoutStatus {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id!: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name!: string;

    constructor(data?: ITyreBrandOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_brand_id = _data["tyre_brand_id"];
            this.tyre_brand_name = _data["tyre_brand_name"];
        }
    }

    static fromJS(data: any): TyreBrandOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_brand_id"] = this.tyre_brand_id;
        data["tyre_brand_name"] = this.tyre_brand_name;
        return data; 
    }
}

export interface ITyreBrandOutputWithoutStatus {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name: string;
}

